"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconJeepFilled = function IconJeepFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "IconJeepFilled"), _react.default.createElement("path", {
    d: "M45.21 27.67L44.21 24.55C43.57 24.12 31.53 22.55 31.53 22.55L28.34 16.43C28.2659 16.2933 28.156 16.1792 28.0222 16.1C27.8883 16.0208 27.7355 15.9793 27.58 15.98H8.34C8.14833 15.9763 7.96104 16.0376 7.80855 16.1537C7.65606 16.2699 7.54733 16.4342 7.5 16.62C7.02 18.73 5.5 25.43 5.05 27.9C4.97499 28.1852 4.97499 28.4849 5.05 28.77L5.84 33.16C5.88259 33.393 6.00648 33.6033 6.18961 33.7534C6.37273 33.9036 6.60321 33.9839 6.84 33.98H9C9 35.3061 9.52678 36.5779 10.4645 37.5155C11.4021 38.4532 12.6739 38.98 14 38.98C15.3261 38.98 16.5979 38.4532 17.5355 37.5155C18.4732 36.5779 19 35.3061 19 33.98H31C31 35.3061 31.5268 36.5779 32.4645 37.5155C33.4021 38.4532 34.6739 38.98 36 38.98C37.3261 38.98 38.5978 38.4532 39.5355 37.5155C40.4732 36.5779 41 35.3061 41 33.98H43.75C44.0665 33.9788 44.3733 33.8704 44.6203 33.6725C44.8673 33.4745 45.0399 33.1987 45.11 32.89L46 30.33V27.67H45.21ZM14 37C13.4067 37 12.8266 36.8241 12.3333 36.4944C11.8399 36.1648 11.4554 35.6962 11.2284 35.1481C11.0013 34.5999 10.9419 33.9967 11.0576 33.4147C11.1734 32.8328 11.4591 32.2983 11.8787 31.8787C12.2982 31.4591 12.8328 31.1734 13.4147 31.0577C13.9967 30.9419 14.5999 31.0013 15.148 31.2284C15.6962 31.4554 16.1648 31.84 16.4944 32.3333C16.8241 32.8267 17 33.4067 17 34C17 34.7957 16.6839 35.5587 16.1213 36.1213C15.5587 36.6839 14.7956 37 14 37V37ZM36 37C35.4067 37 34.8266 36.8241 34.3333 36.4944C33.8399 36.1648 33.4554 35.6962 33.2284 35.1481C33.0013 34.5999 32.9419 33.9967 33.0576 33.4147C33.1734 32.8328 33.4591 32.2983 33.8787 31.8787C34.2982 31.4591 34.8328 31.1734 35.4147 31.0577C35.9967 30.9419 36.5999 31.0013 37.148 31.2284C37.6962 31.4554 38.1648 31.84 38.4944 32.3333C38.824 32.8267 39 33.4067 39 34C39 34.7957 38.6839 35.5587 38.1213 36.1213C37.5587 36.6839 36.7956 37 36 37Z",
    fill: color
  }));
};

IconJeepFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconJeepFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconJeepFilled;
exports.default = _default;